export const settings = ({ settings }) => {
  return {
    notify: {
      schedule: true,
      cancel: true,
      transfer: false,
      send: {
        email: true,
        sms: false,
        push: {
          web: true,
          app: false
        }
      },
      dependents: []
    },
    ...settings
  }
}



// WEBPACK FOOTER //
// ./src/store/getters/settings.js